module.exports = __webpack_public_path__ + "static/media/fotoPrincipal_Dashport_bajaResolucion.72b9abfb.jpg";